import React from 'react';
import { Metadata } from '../../types/Lead';

interface CompanyTagsProps {
  metadata: Metadata;
}

const CompanyTags: React.FC<CompanyTagsProps> = ({ metadata }) => {
  return (
    <div style={{ display: 'flex', gap: '8px', marginBottom: '12px', flexWrap: 'wrap' }}>
      <span style={{
        padding: '4px 12px',
        backgroundColor: '#dbeafe',
        color: '#1d4ed8',
        borderRadius: '16px',
        fontSize: '14px',
        fontWeight: '500'
      }}>
        {metadata.sector}
      </span>
      <span style={{
        padding: '4px 12px',
        backgroundColor: '#f1f5f9',
        color: '#475569',
        borderRadius: '16px',
        fontSize: '14px',
        fontWeight: '500'
      }}>
        {metadata.companySize}
      </span>
      <span style={{
        padding: '4px 12px',
        backgroundColor: '#fce7ff',
        color: '#a855f7',
        borderRadius: '16px',
        fontSize: '14px',
        fontWeight: '500'
      }}>
        {metadata.hqCountry}
      </span>
    </div>
  );
};

export default CompanyTags;